/** The client profile's timeline tabs, in the URL as `?tab=`. */
export const CLIENT_TABS = [
  "activity",
  "memberships",
  "bookings",
  "notes",
  "payments",
  "communications",
] as const;

export type ClientTab = (typeof CLIENT_TABS)[number];
